var App = App || {};

App.SiteNav = (function() {
  'use strict';

  var $html = $('html'),
      $navContainer = $('.site-nav-container'),
      $nav = $('.site-nav'),
      $navPageFade = $('.site-nav-page-block');

  var initialize = function() {
    _bindNavToggle();
    _bindContactNavLink();
  };

  var _bindNavToggle = function() {
    $(document).on('click', '.js-toggle-site-nav', function(e) {
      e.preventDefault();
      _toggleNav();
    });
  };

  var _bindContactNavLink = function() {
    $(document).on('click', '.js-nav-contact', function() {
      _closeNav();
    });
  };

  var _toggleNav = function() {
    $nav.toggleClass('open');
    $nav.hasClass('open') ? _openNav() : _closeNav();
  };

  var _openNav = function() {
    $navPageFade.fadeIn(350);
    $html.addClass('locked');
    $navContainer.slideDown(350, function() {
      $nav.animate({ opacity: 1}, 350);
    });
  };

  var _closeNav = function() {
    $navPageFade.fadeOut(350)
    $html.removeClass('locked');
    $nav.animate({ opacity: 0}, 350, function() {
      $navContainer.slideUp(350);
    });
  };

  return {
    initialize: initialize
  };
}());


